import {EnterpriseModel} from '../../model'
import {aditionalValues} from '../../../../util/utilitario'
export const initValues: EnterpriseModel = {
  id: '',
  ruc: '',
  nombre: '',
  telefono1: '',
  direccion1: '',
  departamentoId1: '',
  provinciaId1: '',
  ubigeo1: '',
  departamentoId2: '',
  telefono2: '',
  direccion2: '',
  provinciaId2: '',
  ubigeo2: '',
  referencia1: '',
  referencia2: '',
  paisId: '',
  ...aditionalValues,
}
